module.exports = "/images/computer-login.svg?b8ddfcb7e2ffd17a62693c3a0170e877";